class AllotmentAvailabilitiesActions {

	// -----------------
	// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
	// They do not themselves have any side-effects; they just describe something that is going to happen.

	public loadAvailabilities(supplierId: number, allotment: AllotmentItem): IAllotmentLoadAvailabilitiesAction {
		return {
			supplierId: supplierId.toString(),
			allotment,
			type: "ALLOTMENT_LOAD_AVAILABILITIES",
		};
	}

	public clearStore(): IAllotmentClearStoreAction {
		return {
			type: "ALLOTMENT_CLEAR_STORE",
		};
	}
}

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionAvailabilitiesCreators = new AllotmentAvailabilitiesActions();



// WEBPACK FOOTER //
// ./src/store/allotments/availabilities-actions.ts